import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

// Upcoming events with their whole card, published by the data job whether or not any playbook picked a fight.
// Events from up to three days ago are kept, the same window the job makes picks for.
export async function fetchUpcomingEvents() {
  const cutoff = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  const snapshot = await getDocs(query(collection(db, 'events'), where('date', '>=', cutoff)));
  // Only events published with their card; older entries hold just a name and can be stale (renamed cards)
  return snapshot.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .filter((evt) => Array.isArray(evt.fights) && evt.fights.length > 0);
}

// Names compared loosely: case, accents and punctuation ignored ("Ode' Osbourne" = "Ode Osbourne")
export const plainName = (name) => String(name || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9 ]/g, '')
  .replace(/\s+/g, ' ')
  .trim();
